module.exports = __webpack_public_path__ + "static/media/logo-icon.11e6f859.png";